import { render, staticRenderFns } from "./ProductsCard.vue?vue&type=template&id=4c26e6e9&scoped=true&"
import script from "./ProductsCard.vue?vue&type=script&lang=js&"
export * from "./ProductsCard.vue?vue&type=script&lang=js&"
import style0 from "./ProductsCard.vue?vue&type=style&index=0&id=4c26e6e9&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c26e6e9",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductImageWatermark: require('/var/www/fs-store/components/ProductImageWatermark.vue').default})
